import React from 'react';

import "./style.css";

export const ICON_TYPE = {
  GALLERY: "cn-webviewer-icon-gallery",
  BOOKMARK: "cn-webviewer-icon-bookmark",
  SHARE: "cn-webviewer-icon-share",
  SOCIAL: {
    PINTEREST: "cn-webviewer-icon-social-pinterest",
    YOUTUBE: "cn-webviewer-icon-social-youtube",
    EMAIL: "cn-webviewer-icon-social-youtube",
    GITHUB: "cn-webviewer-icon-social-youtube",
    TUMBLR: "cn-webviewer-icon-social-tumblr",
    FACEBOOK: "cn-webviewer-icon-social-facebook",
    LINKEDIN: "cn-webviewer-icon-social-linkedin",
    TWITTER: "cn-webviewer-icon-social-twitter",
    GOOGLE_PLUS: "cn-webviewer-icon-social-google-plus"
  },
  TEXT_MODE: "cn-webviewer-icon-reading-mode",
  AUDIO_MODE: "cn-webviewer-icon-listen-mode",
  VIDEO_MODE: "cn-webviewer-icon-play-bold",
  CIRCLE: "cn-webviewer-icon-circle-bold",
  VOLUME: "cn-webviewer-icon-volume",
  VOLUME_OFF: "cn-webviewer-icon-volume-off",
  VOLUME_MEDIUM: "cn-webviewer-icon-volume-medium",
  MAIN_PLAY: "cn-webviewer-icon-main-play",
  VIDEO_PLAY: "cn-webviewer-icon-play",
  VIDEO_PAUSE: "cn-webviewer-icon-pause",
  VIDEO_REPEAT: "cn-webviewer-icon-repeat",
  VIDEO_PREVIOUS: "cn-webviewer-icon-previous",
  VIDEO_NEXT: "cn-webviewer-icon-next",
  SUBTITLE: "cn-webviewer-icon-subtitle",
  BELL: "cn-webviewer-icon-bell",
  SETTINGS: "cn-webviewer-icon-settings",
  SETTINGS_PRESSED: "cn-webviewer-icon-settings-pressed",
  FULL_SCREEN: "cn-webviewer-icon-fullscreen",
  EXIT_FULL_SCREEN: "cn-webviewer-icon-exit-fullscreen",
  GALLERY_FIRST: "cn-webviewer-icon-first",
  GALLERY_LAST: "cn-webviewer-icon-last",
  LIST: "cn-webviewer-icon-list",
  FONT: "cn-webviewer-icon-font",
  RESIZE_WHITE: "cn-webviewer-icon-resize-white",
  RESIZE_GREY: "cn-webviewer-icon-resize-grey",
  BACKWARD: "cn-webviewer-icon-backward",
  FORWARD: "cn-webviewer-icon-forward",
  CLOSE: "cn-webviewer-icon-close",
  CHECK: "cn-webviewer-icon-check",
  DISABLED: "disabled",
};

/**
 * props:
 * type, onClick, label = "", activeState = false
 * @param props
 * @returns {XML}
 * @constructor
 */
export const IconButton = (props) => {

  const {
    hoverEnabled,
    activeState,
    type,
    onClick,
    label,
    disabled,
    className,
  } = props;

  const onMouseOver = (e) => {
    if (hoverEnabled) {
      let className = null;
      [].slice.call(e.target.classList).forEach((cl) => {
        if (cl.match(/cn\-icon/)) {
          className = cl;
        }
      });
      if (className && !disabled) {
        e.target.classList.add(className + "-pressed");
      }
    }
  };
  const onMouseLeave = (e) => {
    let className = null;
    if (!activeState && (hoverEnabled || disabled)) {
      [].slice.call(e.target.classList).forEach((cl) => {
        if (cl.match(/pressed/)) {
          className = cl;
        }
      });
      if (className && e.target.classList.contains(className)) {
        e.target.classList.remove(className);
      }
    }

  };

  let cl = type + (activeState ? '-pressed' : '');
  return (
    <button
      className={`icon ${cl} btn ${!!className ? className : ''}`}
      onClick={onClick}
      onMouseOver={(e) => onMouseOver(e)}
      onMouseLeave={(e) => onMouseLeave(e)}
    >
      {label ? label : ""}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/font-icons/IconButton.jsx